//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/NXObject.js";
import "../no/Expression.js";
import "../no/SelectDisplayableObject.js";
import "../no/ScCollector.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/Features.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AlignmentAngle",0,"Expression",0],[1,"AlignmentPlane",0,"SelectDisplayableObject",0],[0,"AttachmentDirection",1,0],[1,"AttachmentFace",0,"ScCollector",0],[1,"AttachmentStiffener",0,"SelectDisplayableObjectList",0],[0,"BoundaryOkay",1,0],[1,"EndAttachment",0,"ScCollector",0],[0,"KeepAttachmentFace",1,0],[0,"KeepAttachmentStiffener",1,0],[0,"KeepEndAttachment",1,0],[0,"KeepReinforcementFace",1,0],[0,"KeepReinforcementStiffener",1,0],[0,"KeepStartAttachment",1,0],[0,"KeepStartAttachmentLimit",1,0],[0,"PickPointOnAttachment",1,0],[0,"PickPointOnReinforcement",1,0],[0,"ReinforcementDirection",1,0],[1,"ReinforcementFace",0,"ScCollector",0],[1,"ReinforcementStiffener",0,"SelectDisplayableObjectList",0],[1,"StartAttachment",0,"ScCollector",0],[1,"StartAttachmentLimit",0,"ScCollector",0]],[],[]];
SPLM.Features.ShipDesign.BracketBoundaryBuilder = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.BracketBoundaryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;